import { DateTime as DT } from 'luxon';
import LeadStatus from './LeadRows/LeadStatus';
import LeadAction from './LeadRows/LeadAction';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import type { LeadRowProps } from './types';

const LeadTableRow = ({ lead, fetchLeads, setClientInfoId, setTasksLeadId, setNewSale }: LeadRowProps) => {
    const { t } = useTranslation(['Leads', 'common']);
    const { showDlg } = useModal();
    const dtC = DT.fromMillis(lead?.leadCreated || 0).toLocaleString(DT.DATE_MED);
    const dtU = DT.fromMillis(lead?.leadUpdated || 0).toLocaleString(DT.DATE_MED);
    const sourceName = String(lead?.leadSourceName || '').trim();
    const sourceMessage = String(lead?.leadSourceMessage || '').trim();

    const showSourceMessage = () => {
        showDlg({
            type: 'info',
            title: t('fields.source'),
            text: (
                <>
                    <h6 className="mb-1">{sourceName || '-'}</h6>
                    <p className="mb-0 text-break">{sourceMessage || t('source.noMessage')}</p>
                </>
            ),
            buttons: [{ title: t('common:buttons.ok'), variant: 'primary' }],
        });
    };

    return (
        <tr>
            <td className="name">
                <Col>
                    <Link to={`/leads/${lead.ID}`}>
                        <h6 className="mb-1 cursor-pointer text-break">{lead.clientName}</h6>
                        <p className="text-muted f-12 mb-0 my-1">{lead.clientPhone}</p>
                    </Link>
                </Col>
                <Col className="d-block d-md-none">
                    <LeadStatus
                        leadStatus={lead?.leadStatus || 0}
                        leadPendingDt={lead?.leadPendingDt}
                    />
                </Col>
            </td>
            <td className="source text-truncate">
                {sourceName ? (
                    <button
                        type="button"
                        className="btn btn-link p-0 text-start text-truncate d-inline-block w-100"
                        onClick={showSourceMessage}
                        title={sourceMessage || t('source.noMessage')}
                    >
                        {sourceName}
                    </button>
                ) : (
                    <span className="text-muted">-</span>
                )}
            </td>
            <td className="status">
                <LeadStatus
                    leadStatus={lead?.leadStatus || 0}
                    leadPendingDt={lead?.leadPendingDt}
                />
            </td>
            <td className="updated">
                <h6 className="mb-1 cursor-pointer text-break">{dtC}</h6>
                <p className="text-muted f-12 mb-0 my-1">{dtU}</p>
            </td>
            <td className="action">
                <LeadAction
                    lead={lead}
                    fetchLeads={fetchLeads}
                    setClientInfoId={setClientInfoId}
                    setTasksLeadId={setTasksLeadId}
                    setNewSale={setNewSale}
                />
            </td>
        </tr>
    );
};

export default LeadTableRow;
